export const SET_EMBEDDINGS = 'SET_EMBEDDINGS';
